import React from "react"
import Select, { components } from "react-select"
import "./OrderField.css"
import { MagnifierIcon, CloseIcon } from "../../Icons"

const selectStyle = {
  clearIndicator: () => ({}),
  container: () => ({}),
  control: () => ({}),
  dropdownIndicator: () => ({}),
  group: () => ({}),
  groupHeading: () => ({}),
  indicatorsContainer: () => ({}),
  indicatorSeparator: () => ({}),
  input: () => ({}),
  loadingIndicator: () => ({}),
  loadingMessage: () => ({}),
  menu: () => ({}),
  menuList: () => ({}),
  menuPortal: () => ({}),
  multiValue: () => ({}),
  multiValueLabel: () => ({}),
  multiValueRemove: () => ({}),
  noOptionsMessage: () => ({}),
  option: () => ({}),
  placeholder: () => ({}),
  singleValue: () => ({}),
  valueContainer: () => ({})
}

function Menu(props) {
  const { children, innerRef, innerProps } = props
  return (
    <div className={`Menu ${props.placement}`} {...innerProps} ref={innerRef}>
      <div className="menu-content">{children}</div>
    </div>
  )
}

function RemoveValue(props) {
  return (
    <components.MultiValueRemove {...props}>
      <CloseIcon />
    </components.MultiValueRemove>
  )
}

class OrderField extends React.Component {
  handleChange(data, { action }) {
    const { form, field } = this.props
    form.setFieldTouched(field.name)
    switch (action) {
      case "select-option":
      case "remove-value":
        form.setFieldValue(field.name, data)
        break
      default:
        break
    }
  }
  render() {
    const props = this.props
    const {
      field,
      form: { touched, errors }
    } = this.props

    let status = "default"
    if (touched[field.name] && errors[field.name]) {
      status = "has-error"
    } else if (
      touched[field.name] &&
      field.value &&
      field.value.length &&
      !errors[field.name]
    ) {
      status = "is-fixed"
    }

    return (
      <>
        <Select
          className={`OrderField ${status}`}
          classNamePrefix="OrderField"
          styles={selectStyle}
          isClearable={false}
          menuPlacement="auto"
          onChange={this.handleChange.bind(this)}
          {...props}
          components={{
            ...props.components,
            Menu: { ...props.components }.hasOwnProperty("Menu")
              ? { ...props.components }.Menu
              : Menu,
            DropdownIndicator: () => <MagnifierIcon />,
            MultiValueRemove: RemoveValue
          }}
        />
        {touched[field.name] &&
          errors[field.name] && (
            <div className="error-message">{errors[field.name]}</div>
          )}
      </>
    )
  }
}
export default OrderField
